import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AstrologyPage = lazy(() => import('../pages/astrology/page'));
const FourPillarsPage = lazy(() => import('../pages/four-pillars/page'));
const LiveReportPage = lazy(() => import('../pages/live-report/page'));
const TokenUsagePage = lazy(() => import('../pages/token-usage/page'));
const CheckoutPage = lazy(() => import('../pages/checkout/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const CelebrityBlogPage = lazy(() => import('../pages/celebrity-saju/page'));
const CelebrityDetailPage = lazy(() => import('../pages/celebrity-saju/detail'));
const DreamPage = lazy(() => import('../pages/dream/page'));
const DestinyGPTPage = lazy(() => import('../pages/destiny-gpt/page'));
const AnnualReportPage = lazy(() => import('../pages/annual-report/page'));
const LifetimeReportPage = lazy(() => import('../pages/lifetime-report/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogPostPage = lazy(() => import('../pages/blog/post'));
const PremiumReportPage = lazy(() => import('../pages/premium-report/page'));
const BasicReportPage = lazy(() => import('../pages/basic-report/page'));
const VipReportPage = lazy(() => import('../pages/vip-report/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/astrology',
    element: <AstrologyPage />,
  },
  {
    path: '/four-pillars',
    element: <FourPillarsPage />,
  },
  {
    path: '/live-report',
    element: <LiveReportPage />,
  },
  {
    path: '/token-usage',
    element: <TokenUsagePage />,
  },
  {
    path: '/checkout',
    element: <CheckoutPage />,
  },
  {
    path: '/celebrity-saju',
    element: <CelebrityBlogPage />,
  },
  {
    path: '/celebrity-saju/:slug',
    element: <CelebrityDetailPage />,
  },
  {
    path: '/dream',
    element: <DreamPage />,
  },
  {
    path: '/destiny-gpt',
    element: <DestinyGPTPage />,
  },
  {
    path: '/annual-report',
    element: <AnnualReportPage />,
  },
  {
    path: '/lifetime-report',
    element: <LifetimeReportPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogPostPage />,
  },
  {
    path: '/premium-report',
    element: <PremiumReportPage />,
  },
  {
    path: '/basic-report',
    element: <BasicReportPage />,
  },
  {
    path: '/vip-report',
    element: <VipReportPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;